import { generatePath } from 'react-router-dom';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response, SelectItemProps } from '@ui/src';
import { PspPartnerItem, IntegrationLog } from '../types';
import { integrationLogsApi } from './service';

import { BankRoutes } from '../../../routes';

export interface IntegrationLogsState {
  logs?: IntegrationLog[];
  pagination?: Pagination;
  pspPartners?: SelectItemProps[];
  log?: IntegrationLog;
}

const initialState: IntegrationLogsState = {};

export const integrationLogsSlice = createSlice({
  name: 'integrationLogs',
  initialState,
  reducers: {
    clearIntegrationLog: (state) => {
      state.log = undefined;
    },
    clearIntegrationLogsState: (state) => {
      state.logs = undefined;
      state.pagination = undefined;
      state.pspPartners = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      integrationLogsApi.endpoints.getPspPartnerList.matchFulfilled,
      (state, action: PayloadAction<Response<PspPartnerItem>>) => {
        state.pspPartners = action.payload.data.edges.map((item) => ({
          name: item.node.companyName,
          value: item.node.id,
        }));
      },
    );
    builder.addMatcher(
      integrationLogsApi.endpoints.getIntegrationsLogs.matchFulfilled,
      (state, action: PayloadAction<Response<IntegrationLog>>) => {
        state.logs = action.payload.data?.edges?.map((item) => ({
          ...item.node,
          urlList: generatePath(BankRoutes.INTEGRATIONS_LOGS_ITEM, {
            logId: item.node.id,
          }),
          types: item?.node?.type,
          pspPartnerIds: item?.node?.pspPartnerId,
          transactionIds: item?.node?.transactionId,
        }));

        state.pagination = action.payload.data?.pageInfo;
      },
    );
    builder.addMatcher(
      integrationLogsApi.endpoints.getIntegrationsLogsById.matchFulfilled,
      (state, action: PayloadAction<{ data: IntegrationLog }>) => {
        state.log = {
          ...action.payload.data,
          types: action.payload.data?.type,
        };
      },
    );
  },
});

export const { clearIntegrationLogsState, clearIntegrationLog } =
  integrationLogsSlice.actions;

export default integrationLogsSlice.reducer;
